import { connect } from 'react-redux';

import { deleteById, Entities, fetchByCompanyId, getEntities, patch, save } from 'src/common';
import { getOwnCompany } from 'src/selectors/bus-companies';
import CalendarSeasonCalculationAdministration from 'src/components/administration/calendar-season-calculation/calendar-season-calculation-administration';

const mapStateToProps = state => {
    return {
        selectedCompany: state.selectedCompany,
        company: getOwnCompany(state),
        calendarSeasonCalculation: getEntities(state, Entities.CALENDAR_SEASON_CALCULATION, state.selectedCompany),
        calculations: getEntities(state, Entities.CALCULATION, state.selectedCompany),
        calendarSeason: getEntities(state, Entities.CALENDAR_SEASON, state.selectedCompany),
    };
};

const CalendarSeasonCalculationAdministrationContainer = connect(mapStateToProps, {
    patch,
    fetchByCompanyId,
    deleteById,
    save,
})(CalendarSeasonCalculationAdministration);

export default CalendarSeasonCalculationAdministrationContainer;
